import styled from 'styled-components';

export const FeeSelectInputContainer = styled.div`
    & {
        flex-basis: 45%;
    }
`;
